// @ts-strict-ignore
import {produce} from 'immer';

import {ApiSingleValueResource} from 'common/util/model-resource/api-resource';
import {ModelStatus} from 'common/util/model-resource/model-resource';

import {
  formatCardsInOrder,
  PinnedBookmarkResults,
  pinnedCardClient,
  PinnedCards,
  updatePinnedCard,
} from '../queries/app-api/pinned-card-client';
import {getProjectId} from '../util';

export class HomePinnedCardResource extends ApiSingleValueResource<PinnedBookmarkResults[]> {
  apiClient = pinnedCardClient;

  constructor({projectId = null} = {}) {
    super();
    this.id = projectId ?? getProjectId();
  }

  getPinnedCards(): PinnedCards {
    return formatCardsInOrder(this.get().value);
  }

  async updatePinnedCard(bookmarkId, order): Promise<void> {
    const results = await updatePinnedCard(this.id, bookmarkId, order);
    const updatedValue = produce(this.get().value, (draft) => {
      const targetCard = draft.find((card) => card.order === results.order);
      if (targetCard) {
        // updating existing pin
        targetCard.bookmark = results.bookmark;
      } else {
        // creating new pin
        draft.push(results);
      }
    });
    this.update(updatedValue);
  }

  isPinnedCardsLoading(): boolean {
    return this.get().status === ModelStatus.Loading;
  }
}
